import { FlagsManager } from '../contracts/flags-manager';
import { getFlagsManager } from '../manager';

export function mountDefaultFlagGroup(
  mount: (el: HTMLElement, flagsManager: FlagsManager) => void
): void {
  const fragment = document.createDocumentFragment();
  const el = document.createElement('div');

  fragment.appendChild(el);

  const flagsManager = getFlagsManager();

  mount(el, flagsManager);

  document.body.append(fragment);
}
